import type { PopoverProps as AriaPopoverProps } from "react-aria-components";
import { Popover } from "react-aria-components";

import { cn } from "@/lib/helpers/cn";

type PopoverProps = {
  className?: string;
} & AriaPopoverProps;

export function Popover2({ className, ...props }: PopoverProps) {
  return (
    <Popover
      className={cn(
        "tw:w-(--trigger-width)",
        "tw:bg-fill-white",
        "tw:overflow-hidden",
        "tw:border tw:border-solid tw:border-stroke-tertiary",
        "tw:rounded-lg tw:shadow-lg",
        className,
      )}
      {...props}
    />
  );
}
